import { render, staticRenderFns } from "./AcademyMediaLibrary.vue?vue&type=template&id=ce79179c&scoped=true&"
import script from "./AcademyMediaLibrary.vue?vue&type=script&lang=js&"
export * from "./AcademyMediaLibrary.vue?vue&type=script&lang=js&"
import style0 from "./AcademyMediaLibrary.vue?vue&type=style&index=0&id=ce79179c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce79179c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
